import { render, staticRenderFns } from "./OperaSeoWindow.vue?vue&type=template&id=48716c44&"
import script from "./OperaSeoWindow.vue?vue&type=script&lang=js&"
export * from "./OperaSeoWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports